import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Activity, Phone, Server, PhoneCall } from 'lucide-react';

/**
 * Shared sub-navigation for Hub → Connections, Phone Numbers, SIP Extensions,
 * and SIP Call Logs. All four pages share this nav so users see them as one
 * combined area.
 */
export default function ConnectionsSubNav() {
  const { pathname } = useLocation();
  const tabs = [
    { to: '/hub/connections',    label: 'Live Connections', icon: Activity,  testId: 'subnav-connections' },
    { to: '/hub/phone-numbers',  label: 'Phone Numbers',    icon: Phone,     testId: 'subnav-phone-numbers' },
    { to: '/hub/sip-extensions', label: 'SIP Extensions',   icon: Server,    testId: 'subnav-sip-extensions' },
    { to: '/hub/sip-call-logs',  label: 'Call Logs',        icon: PhoneCall, testId: 'subnav-sip-call-logs' },
  ];

  return (
    <div className="border-b border-border bg-card/30 backdrop-blur-sm" data-testid="connections-subnav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex gap-1">
        {tabs.map((t) => {
          const active = pathname === t.to;
          const Icon = t.icon;
          return (
            <Link
              key={t.to}
              to={t.to}
              data-testid={t.testId}
              className={`flex items-center gap-2 px-4 py-2.5 text-sm border-b-2 transition-colors ${
                active
                  ? 'border-primary text-foreground font-medium'
                  : 'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
              }`}
            >
              <Icon className="w-4 h-4" />
              {t.label}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
